import React, { Component } from "react";
import Popup from "reactjs-popup";
import { Button } from '@progress/kendo-react-buttons';
import axios from 'axios';
import {  ComboBox } from '@progress/kendo-react-dropdowns';
import { filterBy } from '@progress/kendo-data-query';

class SelectHHPopUp extends Component {

  constructor(props) {
    super(props);

    this.state = {
        households:this.props.households,
        result:this.props.households,
        selectedHousehold:'',
        display:'',
        bulkKey:this.props.bulkKey,
        displayName:this.props.displayName,
    }

    this.clearState = this.clearState.bind(this);
    this.mapAcct = this.mapAcct.bind(this);
  }

  componentDidMount(){

  }

  mapAcct(){
    // var user = this.props.user;
    //const headers = { 'authorization': 'Bearer '.concat(user.idToken) };
    const headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

    var payload = {
        company:this.props.company,
        mappingOverride:this.state.selectedHousehold.household,
        bulkKey:this.props.bulkKey,
        displayName:this.props.displayName,
    }

    

    axios.post("api/updateBulkDocumentMappingOverride", payload, {headers}).then(response=>{
        if(response.data.code===200){
            alert("You have updated this documents mapping key.");
        }
        else{
          alert("An error has occurred. Please try again.");
        }
      }).catch(err=>console.log(err));
  }

  onUserChange = (e)=>{
    this.setState({selectedHousehold:e.target.value});
  }

  clearState(){
    this.setState({result:this.props.households, selectedHousehold:''});
  }

  render() {
      return (
        <Popup trigger={this.props.button}  onClose={(e)=>{this.clearState()}} overlayStyle={{ zIndex: 5 }} modal>
          {close => (
            <div className="modal">

                <Button className="close" icon="close" onClick={close} />


                <div className="header" align="left">
                Map Document: <strong>{this.state.displayName}</strong>
                </div>

                <div className="content">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <strong>Map to Existing Household:</strong>
                                </td>
                                <td>
                                    <ComboBox
                                        style={{width:'100%'}}
                                        data={this.state.result}
                                        textField='household'
                                        onChange={this.onUserChange}
                                        filterable={true}
                                        allowCustom={true}
                                        onFilterChange={(e)=>{
                                            this.setState({result:filterBy(this.state.households, e.filter)});
                                        }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>            
                </div>

                <div className="actions">

                    <Button className="button" onClick={() => {close()}}>
                        Close
                    </Button>

                    <Button className="upload" onClick={(event) => {
                        this.mapAcct();
                        this.clearState();
                        close();
                        this.props.refresh();
                        }}>
                        Confirm
                    </Button>

                </div>

            </div>
          )}
        </Popup>

      );
  };

}

export default SelectHHPopUp;